// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__l_VnN","tab":"Tabs_tab__3DlxI","tabActive":"Tabs_tabActive___cdDs"};